const faqs = [
  {
    q: '桔子影视需要注册才能看吗？',
    a: '不需要。桔子影视完全免费开放，无需注册、无需登录即可在线观看全部剧集资源。打开网站，选择您想看的剧，即刻开始播放。',
  },
  {
    q: '桔子影视的画质怎么样？',
    a: '平台支持 1080P 至 4K 多种画质自由切换。采用先进的视频编码技术与智能 CDN 分发，系统会根据您的网络状况自动推荐最佳画质，确保流畅观影体验。',
  },
  {
    q: '剧集更新速度快吗？',
    a: '非常快。桔子影视编辑团队每日同步各大平台最新更新，热播剧通常在播出后 2 小时内上线。平均每日更新 30 部以上剧集内容。',
  },
  {
    q: '可以在手机上观看吗？',
    a: '当然可以。桔子影视网站已全面适配移动端浏览器，同时也提供 iOS 和 Android 客户端 App，支持离线缓存、片单收藏等功能，随时随地追剧。',
  },
  {
    q: '桔子影视支持哪些类型的电视剧？',
    a: '平台覆盖国产剧、韩剧、美剧、日剧、泰剧及海外热门剧集，类型包括古装、都市、悬疑、科幻、喜剧、爱情、历史、谍战、动画等，应有尽有。',
  },
  {
    q: '如何向平台推荐好剧或反馈问题？',
    a: '欢迎通过官网「联系我们」区域的邮箱与我们沟通。商务合作请发至 business@juzitv.com，内容推荐与反馈请发至 contribute@juzitv.com，技术支持请联系 support@juzitv.com。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-question-line text-sm w-4 h-4 flex items-center justify-center"></i>
            常见问答
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">您可能想了解</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">关于桔子影视的常见问题，我们在这里为您一一解答。</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">Q</span>
                {faq.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-7">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}